import { StatusOverview } from "../components/StatusOverview";

/**
 * "Ontwormen & ontvlooien" route — the present-animal deworming / flea status overview (Jmix
 * `OntwormenOverzichtView` migration). A thin shell wiring the reusable {@link StatusOverview} to the
 * `ontwormen-overzicht` feed (GET /api/ontwormen-overzicht; the treatment-type filter param is `type`)
 * and the animal-detail + producten navigation. The shared payload reuses the entingen field keys with
 * the deworming meaning (treatment type / last treatment / next-due date).
 */
export function OntwormenOverzicht({
  onOpenAnimal,
}: {
  onOpenAnimal: (dierId: string, inentingId?: number | null) => void;
}) {
  return (
    <StatusOverview
      config={{
        variant: "ontwormen",
        endpoint: "ontwormen-overzicht",
        typeParam: "type",
        i18nPrefix: "ontwormenOverzicht",
      }}
      onOpenAnimal={onOpenAnimal}
    />
  );
}
